// dashboards-03 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "(1 = pior, 5 = melhor).": "(1 = peor, 5 = mejor).",
    "(antes": "(antes",
    ". Desligar módulo antecede cancelar contrato —": ". Desactivar módulo antecede a cancelar contrato —",
    "/L ·": "/L ·",
    "Alavancas de ticket": "Palancas de ticket",
    "As sugestões só aparecem quando a rede está nos dois quintis inferiores de ticket e a alavanca está desligada. Hoje:": "Las sugerencias solo aparecen cuando la red está en los dos quintiles inferiores de ticket y la palanca está desactivada. Hoy:",
    "Clientes digitais:": "Clientes digitales:",
    "Com erro em aberto": "Con error abierto",
    "Considerados parados": "Considerados detenidos",
    "Contratado": "Contratado",
    "Contratado e sem uso:": "Contratado y sin uso:",
    "Contratados": "Contratados",
    "Conversa comercial sugerida": "Conversación comercial sugerida",
    "Dados de pista de": "Datos de playa de",
    "Em uso": "En uso",
    "Entregas totais": "Entregas totales",
    "Erros em aberto": "Errores abiertos",
    "Escala das barras vai até 50% · azul a partir de 15% de penetração, âmbar abaixo disso.": "La escala de las barras llega hasta 50% · azul a partir de 15% de penetración, ámbar por debajo de eso.",
    "Esta rede está no": "Esta red está en el",
    "Evolução no período": "Evolución en el período",
    "Faturas vencidas": "Facturas vencidas",
    "Indisponível para esta rede": "No disponible para esta red",
    "Insumos da janela:": "Insumos de la ventana:",
    "L / ab.": "L / carg.",
    "Litros / abastecimento": "Litros / carga",
    "Matriz contratado × em uso": "Matriz contratado × en uso",
    "Mediana da carteira": "Mediana de la cartera",
    "Mediana da carteira no mesmo período:": "Mediana de la cartera en el mismo período:",
    "Mostrando as": "Mostrando las",
    "Motivo:": "Motivo:",
    "Mudanças recentes no cadastro": "Cambios recientes en el registro",
    "Módulo": "Módulo",
    "Módulos do produto": "Módulos del producto",
    "Nenhum abastecimento agregado neste período.": "Ninguna carga agregada en este período.",
    "Nenhum abastecimento no período — sem origem para comparar.": "Ninguna carga en el período — sin origen para comparar.",
    "Nenhum módulo avaliado para esta rede.": "Ningún módulo evaluado para esta red.",
    "Nenhum posto ativo nesta rede.": "Ninguna estación activa en esta red.",
    "Nenhum posto com abastecimento no período.": "Ninguna estación con carga en el período.",
    "Nenhum posto com entrega de bomba no período.": "Ninguna estación con entrega de surtidor en el período.",
    "Nenhum sinal de risco acionado nesta janela.": "Ninguna señal de riesgo activada en esta ventana.",
    "Nenhuma alavanca avaliada para esta rede.": "Ninguna palanca evaluada para esta red.",
    "Nenhuma mudança registrada para esta rede.": "Ningún cambio registrado para esta red.",
    "Não foi possível carregar esta seção.": "No fue posible cargar esta sección.",
    "O quintil vem do ticket de todas as redes com movimento no mesmo período.": "El quintil proviene del ticket de todas las redes con movimiento en el mismo período.",
    "Onde": "Dónde",
    "Para": "Para",
    "Pelo app": "Por la aplicación",
    "Penetração por posto": "Penetración por estación",
    "Período anterior:": "Período anterior:",
    "Por posto, o pico diário vai de": "Por estación, el pico diario va de",
    "Postos ativos": "Estaciones activas",
    "Postos: último abastecimento e erros": "Estaciones: última carga y errores",
    "Quem abastece pelo": "Quién carga combustible por la",
    "Quem usa:": "Quién usa:",
    "R$ / L": "R$ / L",
    "R$ por litro": "R$ por litro",
    "Receita": "Ingresos",
    "Receita no período": "Ingresos en el período",
    "Resumo operacional": "Resumen operativo",
    "Revenda:": "Revendedor:",
    "Revendas (": "Revendedores (",
    "Risco de downgrade": "Riesgo de downgrade",
    "Sem amostra suficiente na carteira para comparar (mínimo de 3 redes de cada lado) —": "Sin muestra suficiente en la cartera para comparar (mínimo de 3 redes de cada lado) —",
    "Sem amostra suficiente na carteira para posicionar o ticket desta rede em quintil.": "Sin muestra suficiente en la cartera para posicionar el ticket de esta red en quintil.",
    "Sem app": "Sin aplicación",
    "Sem entregas de bomba no período": "Sin entregas de surtidor en el período",
    "Sem entregas de bomba registradas neste período.": "Sin entregas de surtidor registradas en este período.",
    "Sem nenhum abastecimento nos últimos": "Sin ninguna carga en los últimos",
    "Sinais e risco": "Señales y riesgo",
    "Tendência da penetração": "Tendencia de la penetración",
    "Tentar de novo": "Intentar de nuevo",
    "Ticket médio da rede": "Ticket promedio de la red",
    "Ticket por origem do abastecimento": "Ticket por origen de la carga",
    "Ticket por posto": "Ticket por estación",
    "Valor identificado": "Valor identificado",
    "Visão geral da rede": "Visión general de la red",
    "Volume agregado até": "Volumen agregado hasta",
    "abastecimentos (antes": "cargas (antes",
    "amostra:": "muestra:",
    "app": "aplicación",
    "cadastrada em": "registrada en",
    "clientes ativos (antes": "clientes activos (antes",
    "clientes.": "clientes.",
    "com erro de concentrador não resolvido": "con error de concentrador sin resolver",
    "contra": "contra",
    "dias · é o sinal de churn mais forte do painel": "días · es la señal de churn más fuerte del panel",
    "em uso": "en uso",
    "gasta": "gasta",
    "mudanças mais recentes — pode haver mais histórico além destas.": "cambios más recientes — puede haber más historial además de estos.",
    "nos últimos 7 dias.": "en los últimos 7 días.",
    "novos ·": "nuevos ·",
    "não contratado, sem preço declarado": "no contratado, sin precio declarado",
    "não usam": "no usan",
    "não usam.": "no usan.",
    "oportunidade de upsell": "oportunidad de upsell",
    "por abastecimento que quem passa pela automação de pista": "por carga que quien pasa por la automatización de playa",
    "postos ativos": "estaciones activas",
    "redes usam ·": "redes usan ·",
    "score": "score",
    "usam,": "usan,",
    "· 1º faturamento em": "· 1.ª facturación en",
    "· a ingestão é D-1.": "· la ingesta es D-1.",
    "· o dia corrente entra ao vivo.": "· el día actual entra en vivo.",
    "· quem não usa:": "· quién no usa:",
    "Último acesso ao admin": "Último acceso al panel",
    "Último erro": "Último error",
    "é o que aparece primeiro numa renovação para baixo.": "es lo que aparece primero en una renovación a la baja.",
};

export default catalogo;
